export default __webpack_public_path__ + "static/media/hajj.559991d7.png";